import { css, Global, type Theme } from "@emotion/react";

import "normalize.css";

import "@fontsource-variable/inter";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

import "react-loading-skeleton/dist/skeleton.css";

import "@flaticon/flaticon-uicons/css/regular/straight.css";
import "@flaticon/flaticon-uicons/css/solid/straight.css";

import "src/assets/icon-fonts/exonn-12/style.css";
import "src/assets/icon-fonts/exonn-12/style.css";
import "src/assets/icon-fonts/exonn-15/style.css";
import "src/assets/icon-fonts/exonn-20/style.css";
import "src/assets/icon-fonts/exonn-15-filled/style.css";

export const GlobalStyles = () => {
  return <Global styles={rootStyles} />;
};

const rootStyles = (theme: Theme) => {
  return css`
    #root {
      white-space: pre-line;
    }
    .fi {
      display: flex;
    }

    *,
    *:before,
    *:after {
      box-sizing: border-box;
    }

    body {
      font-family: ${theme.fonts.normal};
      background-color: ${theme.colorsV2.grey[50]};
      color: ${theme.colorsV2.fg.default};
    }

    button {
      color: ${theme.colorsV2.fg.default};
      font-weight: 400;
    }

    .MuiPickersPopper-root {
      z-index: 99999 !important;
    }
  `;
};
